import { useState, useEffect, useRef } from 'react';
import { FiSearch, FiChevronDown, FiMail, FiPhone } from 'react-icons/fi';
import styles from './OfferingsPage.module.css';

export default function OfferingsMemberSelect({ value, displayValue, displayEmail, displayPhone, options, onSelect, disabled = false, compact = false }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const filtered = options.filter((o) => {
    const q = (query || '').toLowerCase();
    return (
      (o.name  || '').toLowerCase().includes(q) ||
      (o.email || '').toLowerCase().includes(q) ||
      (o.phone || '').toLowerCase().includes(q) ||
      (o.ownerName || o.createdByMember?.name || '').toLowerCase().includes(q)
    );
  });

  return (
    <div ref={ref} className={styles.memberDropdownWrap} style={disabled ? { opacity: 0.5, pointerEvents: 'none' } : {}}>
      <div
        className={`${styles.memberDropdownTrigger} ${open ? styles.open : ''}`}
        style={compact ? { minHeight: 32, padding: '4px 8px', gap: 6 } : undefined}
        onClick={() => !disabled && setOpen((o) => !o)}
      >
        {value ? (
          compact ? (
            <span className={styles.memberDropdownName} style={{ fontSize: '0.84rem' }}>
              {displayValue}
            </span>
          ) : (
            <div className={styles.memberDropdownSelected}>
              <div className={styles.memberAvatar}>{displayValue ? displayValue[0].toUpperCase() : '?'}</div>
              <div className={styles.memberDropdownSelectedInfo}>
                <span className={styles.memberDropdownName}>{displayValue}</span>
                {(displayPhone || displayEmail) && (
                  <span className={styles.memberDropdownEmail}>
                    {displayPhone && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                        <FiPhone size={10} /> {displayPhone}
                      </span>
                    )}
                    {displayPhone && displayEmail && (
                      <span style={{ opacity: 0.4, margin: '0 4px' }}>·</span>
                    )}
                    {displayEmail && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                        <FiMail size={10} /> {displayEmail}
                      </span>
                    )}
                  </span>
                )}
              </div>
            </div>
          )
        ) : (
          <span className={styles.placeholder}>Search by name, email or mobile…</span>
        )}
        <FiChevronDown size={15} className={`${styles.chevron} ${open ? styles.rotate : ''}`} />
      </div>

      {open && (
        <div className={styles.memberDropdown}>
          <div className={styles.memberDropdownSearch}>
            <FiSearch size={13} className={styles.memberDropdownSearchIcon} />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className={styles.memberDropdownSearchInput}
              placeholder="Search by name, email or mobile…"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className={styles.memberDropdownList}>
            {filtered.length === 0 ? (
              <div className={styles.dropdownEmpty}>No results found</div>
            ) : (
              filtered.map((o) => (
                <div
                  key={o.id}
                  className={`${styles.memberDropdownItem} ${o.id === value ? styles.active : ''}`}
                  onClick={() => { onSelect(o); setOpen(false); setQuery(''); }}
                >
                  <div
                    className={styles.memberAvatar}
                    style={o.id === value ? { background: 'var(--color-primary)' } : {}}
                  >
                    {o.name[0].toUpperCase()}
                  </div>
                  <div className={styles.memberDropdownItemInfo}>
                    <div className={styles.memberDropdownItemName}>{o.name}</div>
                    <div className={styles.memberDropdownItemEmail}>
                      {(o.ownerName || o.createdByMember?.name) && (
                        <span>{o.ownerName || o.createdByMember?.name}</span>
                      )}
                      {(o.ownerName || o.createdByMember?.name) && (o.phone || o.email) && (
                        <span style={{ opacity: 0.4, margin: '0 4px' }}>Â·</span>
                      )}
                      {o.phone && (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                          <FiPhone size={10} /> {o.phone}
                        </span>
                      )}
                      {o.phone && o.email && (
                        <span style={{ opacity: 0.4, margin: '0 4px' }}>·</span>
                      )}
                      {o.email && (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                          <FiMail size={10} /> {o.email}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
